export const enum ScaleAliasPrefix {
  Space = 'sp_',
  FontSizes = 'fs_',
  LineHeights = 'lh_',
}
